
function cumulativeOffset(element) {
    var top = 0, left = 0;
    do {
        top += element.offsetTop  || 0;
        left += element.offsetLeft || 0;
        element = element.offsetParent;
    } while(element);

    return {
        top: top,
        left: left
    };
}

function viewportDimensions() {
    return {
        width: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
        height: Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
    };
}


module.run(function($rootScope, Page) {
    $rootScope.$on('$stateChangeSuccess', function() {
        Page.scrollTop(0, 0, .5);
    });
});

module.provider('Page', function() {

    var mobileBreakpoint = 800;
    var scrollSpeed = 750; // pixels / second

    this.scrollSpeed = function(speed) {
        if (angular.isDefined(speed)) {
            scrollSpeed = speed;
            return this;
        }
        return scrollSpeed;
    };


    this.mobileBreakpoint = function(bp) {
        if (angular.isDefined(bp)) {
            mobileBreakpoint = bp;
            return this;
        }
        return mobileBreakpoint;
    };


    function Page($window, $document, $timeout, $rootScope) {
        this.showMenu = false;
        this.title = "";

        this.element = function() {
            return angular.element($document[0].getElementById("page"));
        };

        this.viewportDimensions = viewportDimensions;

        this.scrollTo = function(element, duration, offset) {
            return this.scrollToElement(element);
        };

        this.isMobile = function() {
            return viewportDimensions().width <= mobileBreakpoint;
        };

        this.scrollToElement = function(element) {
            var elementHeight, pageHeight, offset, padding;

            element = angular.element(element)[0];

            elementHeight = element.scrollHeight;
            pageHeight = viewportDimensions().height;
            offset = cumulativeOffset(element).top;
            padding = (pageHeight - elementHeight) / 2;

            return this.scrollTop(offset, padding);
        };

        this.getElementOffset = function(element, padding) {
            padding = Math.max(padding || 0, 12);

            if (this.isMobile()) {
                padding = Math.max(padding, 52);
            }

            var scrollTop = $document[0].getElementById("page").scrollTop,
                offset = cumulativeOffset(element[0]);
            return offset.top - scrollTop + 40;
        };

        this.scrollToQuerySelector = function (selector) {
            var element = angular.element($document[0].querySelector(selector));
            return this.element().scrollTo(element, 96, 300);
        };

        this.scrollTop = function(offset, padding, rateFactor) {
            var element = this.element();

            if (!element.length) { return; }

            var oldTop = element.scrollTop(),
                newTop, duration;

            rateFactor = angular.isDefined(rateFactor) ? rateFactor : 1;
            offset = offset || 0;
            padding = Math.max(padding || 0, 36); // 24px for field label, 12 for aesthetics

            if (this.isMobile()) {
                padding = Math.max(padding, 90); // 36 as above, with mobile bar
            }

            newTop = offset - padding;
            duration = Math.abs(oldTop - newTop) / scrollSpeed * rateFactor * 1000;
            return element.scrollTop(newTop, duration);
        };

        this.selectFirstInput = function(element, delay) {
            delay = angular.isDefined(delay) ? delay : 10;
            $timeout(function() {

                if (element[0].tagName === 'INPUT') {
                    element[0].focus();
                    element[0].select();
                    return;
                }

                var inputs = element.find('input');
                for (var i = 0; i < inputs.length; i++) {
                    if (inputs[i].classList.contains('ui-select-search')) continue;
                    inputs[i].focus();
                    inputs[i].select();
                    break;
                }

            }, delay);
        };

        this.setTitle = function(title) {
            if (title) {
                this.title = title + " | DYB";
            }
        };

        this.horizontallyBoundByContent = function(element) {
            var content = $document[0].getElementById('content'),
                contentRect = content.getBoundingClientRect(),
                elementRect = element.getBoundingClientRect();

            return elementRect.left > contentRect.left &&
                   elementRect.right < contentRect.right;
        };

        this.verticallyBoundByContent = function(element) {
            var content = $document[0].getElementById('content'),
                contentRect = content.getBoundingClientRect(),
                elementRect = element.getBoundingClientRect();

            return elementRect.top > contentRect.top &&
                   elementRect.bottom < contentRect.bottom;
        };

        angular.element($window).bind('resize', function(event) {
            $rootScope.$broadcast('resize', event);
        });

    }

    this.$get = function($rootScope, $window, $document, $timeout) {
        var page = new Page($window, $document, $timeout, $rootScope);
        return page;
    };
});
